import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest} from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError, } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
    providedIn: 'root'
  })
  export class FileUploadService {
  
    refNo : string;
  
    constructor(private http: HttpClient,private env: EnvService) {}


       upload(data): Observable<HttpEvent<any>> {  
        const req = new HttpRequest('POST', `${this.env.apiUrl}/file-upload/upload`, data, {
          reportProgress: true,
          responseType: 'json'
        });
    
        return this.http.request(req).pipe(catchError(this.handleError));
      }
     

        getFiles(): Observable<any> {
          return this.http.get(`${this.env.apiUrl}/file-upload/getFiles`)
          .pipe(catchError(this.handleError));;
        }

        download(filename:String){
          return this.http.get(`${this.env.apiUrl}/file-upload/download/${filename}`,httpOptions)
          .pipe(catchError(this.handleError));
        }
  

        downloadFile(filename:String){
            return this.http.get(`${this.env.apiUrl}/file-upload/download/${filename}`,{
                responseType : 'blob',
                headers:new HttpHeaders().append('Content-Type','application/json')
            })
            .pipe(catchError(this.handleError));
        }

        deleteFile(filename:String) : Observable <void>{
          return this.http.delete<void>(`${this.env.apiUrl}/file-upload/delete/${filename}`,httpOptions)
            .pipe(catchError(this.handleError));
           
        }
    
  
      private handleError(errorResponse: HttpErrorResponse) {
        return throwError(errorResponse || "Server Error");
  
        }
  
  }
  